import React from "react";
import "../../Components/Menu/Menu.css";

export default function Marketing() {
  return (
    <div>
      <h4 className="sub-title">GMG kan sende markedsføring til deg</h4>
      <p className="content">
        Tar du i bruk appen, kan GMG sende relevant markedsføring til deg om
        egne tjenester og produkter. Denne markedsføringen kan omhandle nye
        tjenester og funksjonalitet i appen, tips og råd om bilhold, nyheter i
        appen og lignende. Du kan reservere deg mot slik markedsføring ved å
        kontakte oss på {""}
        <a className="mail-lab" href="mailto:hei@bilista.no">
          hei@bilista.no
        </a>
      </p>
    </div>
  );
}
